






































import Vue from "vue";
import { AxiosResponse } from "axios";
// api
import * as adunitApi from "@/features/adunitGroup/axios";
// components
import PageTitle from "@/commons/components/PageTitle.vue";
import AdunitGroupTable from "@/features/adunitGroup/components/AdunitGroupTable.vue";
import DialogCard from "@/commons/components/DialogCard.vue";
// types
import { AdunitGroup, AdunitGroupsResponse } from "@/features/adunitGroup/types";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";

export default Vue.extend({
  name: "AdunitView",
  components: {
    AdunitGroupTable,
    PageTitle,
    DialogCard,
  },
  data() {
    return {
      adunitGroups: [] as AdunitGroup[],
      isLoading: false as boolean,
      showDeleteAdunitGroupDialog: false as boolean,
      selectableAdunitGroup: {
        adunitGroupId: 0,
        adunitGroupName: "",
        publisherName: "",
      } as AdunitGroup,
    };
  },
  created() {
    this.isLoading = true;
    this.getAdunitGroup();
  },
  methods: {
    getAdunitGroup() {
      adunitApi
        .getAdunitGroups()
        .then((res: AxiosResponse<AdunitGroupsResponse>) => {
          this.adunitGroups = res.data.adunitGroups;
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.adUnitGroups"));
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClickDeleteButton() {
      this.isLoading = true;
      adunitApi
        .deleteAdunitGroup(this.selectableAdunitGroup.adunitGroupId)
        .then(() => {
          notifyUtil.notifySuccessMessage(this.$t("adUnitGroup.notify.success.delete"));
          this.closeDeleteDialog();
          this.getAdunitGroup();
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("adUnitGroup.notify.error.delete"));
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    showDeleteDialog(adunitGroup: AdunitGroup) {
      this.selectableAdunitGroup = adunitGroup;
      this.showDeleteAdunitGroupDialog = true;
    },
    closeDeleteDialog() {
      this.selectableAdunitGroup = {
        adunitGroupId: 0,
        adunitGroupName: "",
        publisherName: "",
      };
      this.showDeleteAdunitGroupDialog = false;
    },
  },
});
